import { ROUTES } from 'pages/_constants/Routes';

export const isAuthenticationRoute = (path: string) =>
  [
    ROUTES.AUTH_SIGN_IN,
    ROUTES.AUTH_SIGN_OUT,
    ROUTES.AUTH_SIGN_OUT__INACTIVITY,
    ROUTES.AUTH_PASSWORD_REQUEST,
  ].includes(path.replace(/\/+$/, ''));
